import { Typography } from "common/components";
import {
  FieldConfig,
  FormattedFieldTextFlowData,
  FormattedFieldTextFlowStep,
  useFetchFieldConfig,
} from "core/api";
import { HTMLText } from "core/components/HTMLText";
import { theme } from "styles/theme";
import { FlowStepComponentProps } from "../models";
import { StyledStepContentWrapper } from "../steps.styles";

export type FormattedFieldTextProps = FlowStepComponentProps<
  FormattedFieldTextFlowStep,
  FormattedFieldTextFlowData
>;

/** Formatted Field Text step component
 * Displays a label and a text, where the text supports HTML
 */
export function FormattedFieldText({
  data,
  flowStep,
}: FormattedFieldTextProps): JSX.Element {
  const { formattedFieldText } = data;

  const { entityType = undefined, entityTypeId = undefined } =
    data.entityRef ?? flowStep.config ?? {};
  const { data: fieldConfigs } = useFetchFieldConfig(entityType, entityTypeId);

  const fieldKey = (flowStep.config as any)?.fieldKey;

  const fieldConfig: FieldConfig | undefined = fieldConfigs?.find(
    ({ key: configKey }) =>
      configKey.key === fieldKey?.key && configKey.variant === fieldKey?.variant
  );

  return (
    <StyledStepContentWrapper>
      <Typography variant="h3" color={theme.palette.text.primary}>
        {fieldConfig?.label}
      </Typography>
      <Typography>
        <HTMLText>{formattedFieldText}</HTMLText>
      </Typography>
    </StyledStepContentWrapper>
  );
}
